import { isMobile } from '@site/js/utils/breakpoint'
import { useRef, useState } from 'react'

import {elementTopPosition, getLocationHash, navigationHeight} from '../AnchorNavigationHelperMethods'

let scrollingProgrammatically = null
const FOLD_RATION = 0.2

export const STICKY_NAVIGATION_CLASS_NAME = 'cmp-anchor-navigation--sticky'

export const useAnchorNavigation = props => {
  const [domPageTitles, setDomPageTitles] = useState(null)
  const [temporaryPageTitles, setTemporaryPageTitles] = useState(null)
  const [pageTitles, setPageTitles] = useState(null)
  const [isNavigationExpanded, setIsNavigationExpanded] = useState(false)
  const [isScrollingProgrammatically, setIsScrollingProgrammatically] = useState(false)
  const [initialAnchorNavigationPosition, setInitialAnchorNavigationPosition] = useState(null)
  const [stickyNavigationContainerTopPosition, setStickyNavigationContainerTopPosition] = useState(null)
  const [isMobileLandscape, setIsMobileLandscape] = useState(false)
  const [isOverflowing, setIsOverflowing] = useState(false)
  const [locationHash, setLocationHash] = useState(location.hash)
  const [anchorNavigationActiveItemLabel, setAnchorNavigationActiveItemLabel] = useState(props.anchornavigationlabel || '')
  const [hasClickedOnce, setHasClickedOnce] = useState(false)
  const anchorNavigationContainer = useRef(null)
  const anchorNavigationNavbar = useRef(null)
  const anchorNavigationList = useRef(null)

  const header: HTMLElement = document.querySelector('.cmp-header')
  // eslint-disable-next-line sonarjs/cognitive-complexity

  const setActiveLink = ({ id = null, isClicked = false, isLoadedWithHash = false } = {}) => {
    if (pageTitles) {
      let activeItemLabel = pageTitles[0]?.label
      if (isClicked || isLoadedWithHash) {
        setIsScrollingProgrammatically(true)
        clearTimeout(scrollingProgrammatically)
        scrollingProgrammatically = setTimeout(() => {
          setIsScrollingProgrammatically(false)
        }, 2000)
      }

      ;(domPageTitles as HTMLElement[])?.forEach((domPageTitle, index) => {
        if (domPageTitle.id === id) {
          activeItemLabel = pageTitles[index].label
          pageTitles[index].isActive = true
        } else {
          pageTitles[index].isActive = false
        }

        if ((isClicked || isLoadedWithHash) && domPageTitle.id === id) {
          const elementPosition = domPageTitle.getBoundingClientRect().top
          let offsetPosition = 0;
          if (!hasClickedOnce) {
            setHasClickedOnce(true)
            offsetPosition = elementPosition + window.scrollY - calculateBufferHeight() - navigationHeight(header.offsetHeight)
          } else {
            offsetPosition = elementPosition + window.scrollY - calculateBufferHeight()
          }
          window.scrollTo({ top: offsetPosition, behavior: 'smooth' })
        }
      })

      if (id) {
        if (`#${id}` !== getLocationHash()) {
          setLocationHash(`#${id}`)
        }
      } else {
        setLocationHash('')
      }
      setAnchorNavigationActiveItemLabel(activeItemLabel)
    }
  }

  const calculateBufferHeight = () => {
    if (isMobile) {
      return !hasClickedOnce ? 300 : 120
    }
    return !hasClickedOnce || anchorNavigationContainer.current?.classList.contains(STICKY_NAVIGATION_CLASS_NAME) ? 220 : 100
  }

  const getTitlesAboveFold = (): HTMLElement[] => {
    const foldPosition = Math.floor((isMobileLandscape ? window.innerWidth : window.innerHeight) * FOLD_RATION)
    return (domPageTitles as HTMLElement[])?.filter(title => {
      // offsetParent is null when the title (or an ancestor, e.g. cop_powerportal_flag / KPI gating) is display:none
      if (title.offsetParent === null) return false
      const titleTopPosition = elementTopPosition(title) - foldPosition
      return window.scrollY >= titleTopPosition
    })
  }

  return {
    temporaryPageTitles,
    setTemporaryPageTitles,
    domPageTitles,
    setDomPageTitles,
    locationHash,
    pageTitles,
    setPageTitles,
    isScrollingProgrammatically,
    isOverflowing,
    setIsOverflowing,
    setIsMobileLandscape,
    stickyNavigationContainerTopPosition,
    setStickyNavigationContainerTopPosition,
    initialAnchorNavigationPosition,
    setInitialAnchorNavigationPosition,
    isNavigationExpanded,
    setIsNavigationExpanded,
    anchorNavigationActiveItemLabel,
    setActiveLink,
    getTitlesAboveFold,
    anchorNavigationContainer,
    anchorNavigationNavbar,
    anchorNavigationList,
  }
}
